import React, { useCallback } from 'react';
import type { CouponContentResponse } from '../../../types/front.graphql';
import { CouponDetail } from '../components';
import type { CouponCardType } from '../components/coupon-widget-content/coupon-widget-content.types';
import type { AppBottomSheetAction, AppBottomSheetInjectedProps } from '@kidslabs/mario-nextjs-react-ui-core';

// Re-export for backward compatibility
export type { AppBottomSheetAction };
export type BottomSheetExtraProps = AppBottomSheetInjectedProps;

type ShowCouponDetails = (coupon: CouponContentResponse, variant?: CouponCardType) => void;

export const useShowCouponDetails = (
    bottomSheet: AppBottomSheetAction | undefined,
    styles: { containerStyle: object },
    t: (key: string) => string,
    props: BottomSheetExtraProps
): ShowCouponDetails =>
    useCallback(
        (coupon: CouponContentResponse, variant?: CouponCardType) => {
            if (!bottomSheet) {
                console.warn('Bottom sheet is not available');
                return;
            }
            bottomSheet.inject(
                <CouponDetail variant={variant} dataType="couponContent" coupon={coupon} bottomSheetProps={props} />,
                {
                    title: t('text_detail_coupon'),
                    titleProps: {
                        variant: 'h3',
                        style: {
                            color: 'var(--color-primary-100)',
                            fontWeight: 'var(--font-weight-bold)',
                            textAlign: 'center',
                            width: '100%',
                        },
                    },
                    containerStyle: styles.containerStyle,
                    closeIconProps: {
                        icon: 'blank',
                        disabled: true,
                        iconColor: 'transparent',
                    },
                },
                {
                    enableDynamicSizing: false,
                    scrollEnabled: false,
                    height: 'full',
                },
                undefined,
                {
                    pressBehavior: 'close',
                }
            );
            bottomSheet.show();
        },
        [bottomSheet, styles.containerStyle, props, t]
    );
